import { render } from "./BgDivisionCount.vue?vue&type=template&id=180db6a2&scoped=true"
import script from "./BgDivisionCount.vue?vue&type=script&lang=js"
export * from "./BgDivisionCount.vue?vue&type=script&lang=js"

import "./BgDivisionCount.vue?vue&type=style&index=0&id=180db6a2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-180db6a2"

export default script